// extracted by mini-css-extract-plugin
export default {"footer":"WbTCWE","formActionButtons":"LOENqD","cancelButton":"FUciNy"};